import React from 'react';
interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  padding?: 'none' | 'sm' | 'md' | 'lg';
}
/**
 * Reusable Container component with consistent max-width and padding
 * Provides responsive container sizing across all sections
 *
 * @param size - Container max-width (default: 'lg')
 * @param padding - Vertical and horizontal padding (default: 'lg')
 *
 * @example
 * <Container size="lg" padding="lg">
 *   <YourContent />
 * </Container>
 */
export function Container({
  children,
  className = '',
  size = 'lg',
  padding = 'lg'
}: ContainerProps) {
  const sizeClasses = {
    sm: 'max-w-3xl',
    md: 'max-w-5xl',
    lg: 'max-w-7xl',
    xl: 'max-w-[1440px]',
    full: 'max-w-full' // 100%
  };
  const paddingClasses = {
    none: '',
    sm: 'px-6 py-12 md:px-8 md:py-16',
    md: 'px-6 py-16 md:px-8 md:py-20',
    lg: 'px-6 py-20 md:px-8 md:py-24'
  };
  return <div className={`w-full mx-auto ${sizeClasses[size]} ${paddingClasses[padding]} ${className}`} data-id="element-2207">
      {children}
    </div>;
}